<app-base-modal
  [title]="'Проверка данных из Yandex'"
>
  @if(isLoading) {
    <app-loader/>
  }
  <mat-form-field
    appearance="outline"
    class="form-field none-pointer-events"
  >
    <mat-label>Клики</mat-label>
    <input
      matInput
      type="text"
      [value]="siteClicksData.siteClicks"
    >
  </mat-form-field>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      [disabled]="isError"
      (click)="handleUpdateYandexMetrics()"
    >
      Обновить данные
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
